export default __webpack_public_path__ + "static/media/promo-detail-carbon_money.ca3c1f01.svg";